export default {
  methods: {
    fetchBanner (type) {
      const bannerType = this.selectedServiceInfo?.hasPersonalizedOffers ? 'PERSONALIZED' : type
      const setType = this.bannerType(bannerType)
      this.$apiRequest.get(`banners/${setType}`)
        .then(response => {
          this.promoBanner = response.data || {}
        })
        .catch(e => {
          this.promoBanner = {}
        })
    },
    bannerType (type) {
      switch (type) {
        case 'PERSONALIZED':
          return 'personalized'
        case 'MPAY':
          return 'mpay'
        case 'MOBILE_PREPAID':
          return 'prepaid'
        case 'MOBILE_POSTPAID':
          return 'postpaid'
        default:
          return 'cable'
      }
    }
  }
}
